module.exports = __webpack_public_path__ + "static/img/google_logo.243e9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/google_logo.png
// module id = o2no
// module chunks = 1